import React from 'react';
import { withStyles } from '@material-ui/core';
import Expansion from "components/Expansion";
import InnerExpansion from "./innerExpansion"
import { TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import EmailInvite from "./emailInvite";
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import "./style.css";
import styles from './style';
import Labels from "./labels";
import Field from "./common";
import Icon from "storybookComponents/Icon"
import DefaultValues, { rewardFields } from "../default"
import { brToNl } from "../util/index"
import { CopyIcon, CopiedIcon } from "icons";
import * as path from "constants/path";
import Typography from "@material-ui/core/Typography";
import Switch from "components/Switch/simpleSwitch";

const MenuProps = {
    PaperProps: {
        style: {
            height: 300,
            width: 150,
            position: "absolute",
        },
    },
};

const arrayToObject = (list, key, value) => {
    let result = {};
    list.forEach((obj) => {
        result[obj[key]] = obj[value]
    })
    return result;
}

const renderMenuItem = (item, index) => (
    <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
)


const EditForm = withStyles(styles)(({ utmCodesLink, updateLivePreview, onPropertyChange, onIndexChange, setTitle, propertyList, classes, setFieldValue, setActive, values, id, orgLevel, assetCategory, showNotification }) => {
    const [expanded, setExpanded] = React.useState(Labels.CAMPAIGN_DETAIL);
    const [subExpanded, setSubExpanded] = React.useState(Labels.ENROLL_DETAIL.SMS);
    const [iconStroke, setIconStroke] = React.useState('#333');
    const [copyText, setCopyText] = React.useState("Copy")
    const properties = arrayToObject(propertyList, 'id', 'name')
    const enrollUrl = id ? utmCodesLink.directLink : "A link for your campaign will be generated automatically only after saving the campaign.";

    React.useEffect(() => {
        setTitle([
            { "label": "Referral Campaigns", "link": path.getAppPath(), "active_state": false }, { "label": id ? values.title : "Create Campaign", "link": "#", "active_state": false },
        ])
    }, [])
    const parentExpandedPreview = (panel) => {
        switch (panel) {
            case Labels.ENROLL_DETAIL.MAIN:
                if (subExpanded !== Labels.ENROLL_DETAIL.SMS && subExpanded !== Labels.ENROLL_DETAIL.PORTAL) {
                    setSubExpanded(Labels.ENROLL_DETAIL.SMS);
                    onIndexChange(0)
                    return
                }
                if (subExpanded === Labels.ENROLL_DETAIL.SMS) {
                    onIndexChange(0)
                } else {
                    onIndexChange(1)
                }
                break;
            case Labels.RESIDENT_ENROLL:
                onIndexChange(2)
                break;
            case Labels.THANKYOU_ENROLL:
                onIndexChange(3)
                break;
            case Labels.INVITE_FRIEND.MAIN:
                if (subExpanded !== Labels.INVITE_FRIEND.MAX && subExpanded !== Labels.INVITE_FRIEND.DEFAULT && subExpanded !== Labels.INVITE_FRIEND.CONFIRMATION && subExpanded !== Labels.INVITE_FRIEND.LANDING_PAGE) {
                    setSubExpanded(Labels.INVITE_FRIEND.MAX);
                    onIndexChange(4)
                    return
                }
                if (subExpanded === Labels.INVITE_FRIEND.MAX) {
                    onIndexChange(4)
                } else if (subExpanded === Labels.INVITE_FRIEND.DEFAULT) {
                    onIndexChange(5)
                } else if (subExpanded === Labels.INVITE_FRIEND.CONFIRMATION) {
                    onIndexChange(6)
                } else {
                    onIndexChange(11)
                }
                break;
            case Labels.GET_IN_TOUCH:
                onIndexChange(7)
                break;
            case Labels.DISCOUNT_DETAIL:
                onIndexChange(8)
                break;
            default:
                onIndexChange(12)
                break;
        }
    }

    const childExpansionPreview = (panel) => {
        switch (panel) {
            case Labels.ENROLL_DETAIL.SMS:
                onIndexChange(0)
                break;
            case Labels.ENROLL_DETAIL.PORTAL:
                onIndexChange(1)
                break;
            case Labels.INVITE_FRIEND.MAX:
                onIndexChange(3)
                break;
            case Labels.INVITE_FRIEND.DEFAULT:
                onIndexChange(5)
                break;
            case Labels.INVITE_FRIEND.CONFIRMATION:
                onIndexChange(6)
                break;
            case Labels.INVITE_FRIEND.LANDING_PAGE:
                onIndexChange(11)
                break;
            default:
                onIndexChange(12)
                break;
        }
    }

    const handleExpandedPanel = (panel) => {
        if (panel === expanded)
            setExpanded("");
        else {
            parentExpandedPreview(panel)
            setExpanded(panel);
        }
    };

    const onInnerExpansionChange = (open, panel) => {
        if (panel === subExpanded) {
            setSubExpanded("")
        } else {
            setSubExpanded(panel)
            childExpansionPreview(panel)
        }
    }

    const handleChange = (e) => {
        if (!e.target.value) {
            setActive("inactive")
        }
        if (e.target.name == "propertyId") {
            let p = propertyList.find(i => i.id == e.target.value);
            let property = {
                name: p.name,
                logo: p.propertyLogoUrl,
                orgLogo: p.propertyManagerLogoUrl
            }
            onPropertyChange(property)
        }

        if (e.target.name === "tourCtaUrl") {
            let value = e.target.value + "?" + values.tourCtaUrl.split("?")[1];
            setFieldValue(e.target.name, value);
        } else if (e.target.name === "contactCtaUrl") {
            let value = e.target.value + "?" + values.contactCtaUrl.split("?")[1];
            setFieldValue(e.target.name, value);
        } else {
            setFieldValue(e.target.name, e.target.value);
        }

        if (e.target.name == "reward") {
            let old = localStorage.getItem("reward");
            rewardFields.forEach((name) => {
                if (values[name].includes("$" + old)) {
                    let newValue = values[name].replace("$" + old, "$" + e.target.value)
                    setFieldValue(name, newValue);
                }
            })
            localStorage.setItem("reward", e.target.value);
        }
    }

    const onChange = (e) => {
        setFieldValue(e.target.name, e.target.checked);
        updateLivePreview({ ...values, [e.target.name]: e.target.checked });
    }

    const onInput = (e) => {
        if (e.target.name === "tourCtaUrl") {
            let value = e.target.value + "?" + values.tourCtaUrl.split("?")[1];
            updateLivePreview({
                ...values,
                [e.target.name]: value
            });
        } else if (e.target.name === "contactCtaUrl") {
            let value = e.target.value + "?" + values.contactCtaUrl.split("?")[1];
            updateLivePreview({
                ...values,
                [e.target.name]: value
            });
        } else {
            updateLivePreview({ ...values, [e.target.name]: e.target.value });
        }
    }


    const copyTextToClipboard = () => {
        navigator.clipboard.writeText(enrollUrl).then(function () {
            setCopyText("Copied");
            setTimeout(() => {
                setCopyText("Copy");
            }, 2000)
        }, function (err) {
            console.error('Async: Could not copy text: ', err);
        });
    }


    const rightSection = (open) => (
        open && id ? <div className={classes.rightSection} onMouseEnter={() => setIconStroke('#26BBED')}
            onMouseLeave={() => setIconStroke('#333')} onClick={copyTextToClipboard}>
            {
                copyText === "Copy" ? <CopyIcon stroke={iconStroke} fill="none" /> : <CopiedIcon />
            }
            <div className={`${classes.colorCopy} ${copyText === 'Copied' && classes.copiedColor}`}>{copyText}</div>
        </div> : null
    )

    const getHelperText = (limit, value) => {
        return `${value.length}/${limit}`;
    };

    const handleFocus = (event) => {
        if (expanded === Labels.ENROLL_DETAIL.MAIN && subExpanded === Labels.ENROLL_DETAIL.SMS) {
            if (event.target.name == "emailBody") {
                onIndexChange(0);
                return;
            }
            if (event.target.name == "emailSms") {
                onIndexChange(9);
                return;
            }
        }
        if (expanded == Labels.DISCOUNT_DETAIL) {
            if (event.target.name == "residentDiscountEmailBody") {
                onIndexChange(8);
                return;
            }
            if (event.target.name == "residentDiscountEmailSms") {
                onIndexChange(10);
                return;
            }
        }
    };

    const handleToggle = (current, prev) => {
        setFieldValue("emailValidationStatus", current);
        updateLivePreview({ ...values, emailValidationStatus: current });
        return current;
    };

    return (
        <div className={classes.superContainer}>
            {/* Referral Campaign Details */}
            <Expansion
                expanded={expanded === Labels.CAMPAIGN_DETAIL}
                name={Labels.CAMPAIGN_DETAIL}
                handleExpandedPanel={handleExpandedPanel}
                header={Labels.CAMPAIGN_DETAIL}
            >
                <div className={`${classes.labelContainer} hyly-rsvp-form`}>
                    <div class="hyly-rsvp-form">
                        {
                            orgLevel ?
                                <div className={classes.selectField}>
                                    <InputLabel className={classes.labelStyle} id="demo-simple-select-label">Property</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        name="propertyId"
                                        value={values.propertyId}
                                        onChange={handleChange}
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null,
                                            classes: {
                                                list: classes.selectOptionList,
                                                paper: classes.selectOptionPaper
                                            }
                                        }}
                                        disabled={Boolean(!orgLevel)}
                                    >
                                        {
                                            propertyList.map(renderMenuItem)
                                        }

                                    </Select>
                                </div> : null
                        }
                        <Field onInput={onInput} fullWidth className="hyly-half-input" name="title" onChange={handleChange} value={values.title} label="Referral Campaign Title*" />
                        <Field onInput={onInput} fullWidth type="number" className="hyly-half-input" name="reward" onChange={handleChange} value={values.reward} label="Referral Reward*" InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }} />
                    </div>
                </div>
            </Expansion>
            {/* A. Community Invites Residents To Enroll */}
            <div className={classes.expansionMargin}>
                <Expansion
                    expanded={expanded === Labels.ENROLL_DETAIL.MAIN}
                    name={Labels.ENROLL_DETAIL.MAIN}
                    handleExpandedPanel={handleExpandedPanel}
                    header={Labels.ENROLL_DETAIL.MAIN}
                >
                    <div className={classes.labelContainer}>
                        <InnerExpansion
                            open={subExpanded === Labels.ENROLL_DETAIL.SMS}
                            header={Labels.ENROLL_DETAIL.SMS}
                            onChange={onInnerExpansionChange}
                        >
                            <EmailInvite
                                onInput={onInput}
                                classes={classes}
                                label_1="Email-Subject"
                                label_2="Email-Body"
                                label_3="SMS"
                                name_1="emailSubject"
                                name_2="emailBody"
                                name_3="emailSms"
                                name_image="image"
                                value_1={values.emailSubject}
                                value_2={values.emailBody.replace(/\%reward\%/, "$" + values.reward)}
                                value_3={values.emailSms?.replace(/\%reward\%/, "$" + values.reward)}
                                value_image={values.image}
                                onChange={handleChange}
                                onFocus={handleFocus}
                                id={id}
                                assetCategory={assetCategory}
                                showNotification={showNotification}
                                aboveImageText="Upload an image, a resident can see when invited"
                            />
                        </InnerExpansion>
                        <div className={classes.horizontalLine}></div>
                        <InnerExpansion
                            open={subExpanded === Labels.ENROLL_DETAIL.PORTAL}
                            header={Labels.ENROLL_DETAIL.PORTAL}
                            onChange={onInnerExpansionChange}
                        >
                            <div className={`${classes.labelContainer} campaign-radio`}>
                                <div className={classes.uploadText}>Design a CTA for this campaign to display on your resident portal</div>
                                {
                                    values.ctaDesign === "banner_with_cta" ? <div className={`${classes.labelContainer} hyly-rsvp-form`}>
                                        <Field onInput={onInput} className="hyly-half-input" label="CTA Text" name="ctaText" onChange={handleChange} value={values.ctaText} inputProps={{ maxLength: 20 }} getHelperText={getHelperText.bind(this, 20)} />
                                        <div className={classes.imageText}>Banner Text</div>
                                        <Field onInput={onInput} multiline inputProps={{ maxLength: 100 }} getHelperText={getHelperText.bind(this, 100)} fullWidth name="bannerText" onChange={handleChange} value={values.bannerText.replace(/\%reward\%/, "$" + values.reward)} variant="outlined" />
                                    </div> : null
                                }

                            </div>
                        </InnerExpansion>

                        <div className={classes.horizontalLine}></div>
                        <InnerExpansion
                            open={subExpanded === Labels.ENROLL_DETAIL.DIRECT}
                            header={Labels.ENROLL_DETAIL.DIRECT}
                            onChange={onInnerExpansionChange}
                            rightSection={rightSection}
                        >
                            <div className={classes.labelContainer}>
                                <div class="hyly-rsvp-form" id="hyly-disabled">
                                    <Field name="directLink" disabled value={enrollUrl} multiline fullWidth variant="outlined" />
                                </div>
                            </div>
                        </InnerExpansion>


                    </div>
                </Expansion>
            </div>
            {/* B. Resident Enrolls */}
            <div className={classes.expansionMargin}>
                <Expansion
                    expanded={expanded === Labels.RESIDENT_ENROLL}
                    name={Labels.RESIDENT_ENROLL}
                    handleExpandedPanel={handleExpandedPanel}
                    header={Labels.RESIDENT_ENROLL}
                >
                    <div className={classes.marginStyle}>

                        <div className={classes.labelContainer}>
                            <div class="hyly-rsvp-form">
                                <Field onInput={onInput} fullWidth name="residentBannerTitle" onChange={handleChange} value={values.residentBannerTitle} label="Popup Title" />
                                <div className={classes.imageText}>Header</div>
                                <Field onInput={onInput} name="residentEnrollHeader" onChange={handleChange} value={values.residentEnrollHeader.replace(/\%reward\%/, "$" + values.reward)} multiline fullWidth variant="outlined" />

                                <div className={`${classes.highLightText} ${classes.labelContainer} ${classes.bottomMargin}`}>Define the pitch for the resident to enroll in this campaign</div>
                                <Field onInput={onInput} name="pitchMessage" onChange={handleChange} value={values.pitchMessage.replace(/\%reward\%/, "$" + values.reward)} multiline fullWidth variant="outlined" />

                                <div className={classes.imageText}>Footer</div>
                                <Field onInput={onInput} name="residentEnrollFooter" onChange={handleChange} value={values.residentEnrollFooter.replace(/\%reward\%/, "$" + values.reward)} multiline fullWidth variant="outlined" />
                                <div className={classes.emailValidation}>
                                    <span>Email Validation:</span>
                                    <Switch toggled={values.emailValidationStatus} onToggle={handleToggle} />
                                </div>
                            </div>
                        </div>
                    </div>
                </Expansion>
            </div>

            {/* C. Resident Receives Email Upon Enrolling */}
            <div className={classes.expansionMargin}>
                <Expansion
                    expanded={expanded === Labels.THANKYOU_ENROLL}
                    name={Labels.THANKYOU_ENROLL}
                    handleExpandedPanel={handleExpandedPanel}
                    header={Labels.THANKYOU_ENROLL}
                >
                    <div className={classes.marginStyle}>
                        <div className={`${classes.highLightText} ${classes.labelContainer}`}> Thank You email will be sent to residents upon enrolling</div>
                        <EmailInvite
                            onInput={onInput}
                            classes={classes}
                            label_1="Email-Subject"
                            label_2="Email-Body"
                            label_4="Email-Title"
                            name_1="residentThankYouEmailSubject"
                            name_2="residentThankYouEmailBody"
                            name_4="residentThankYouEmailTitle"
                            name_image="residentThankYouImage"
                            value_1={values.residentThankYouEmailSubject}
                            value_2={values.residentThankYouEmailBody ? values.residentThankYouEmailBody.replace(/\%reward\%/, "$" + values.reward) : ""}
                            value_image={values.residentThankYouImage}
                            value_4={values.residentThankYouEmailTitle}
                            onChange={handleChange}
                            id={id}
                            assetCategory={assetCategory}
                            showNotification={showNotification}
                            aboveImageText="Upload an image, a resident can see when successfully enrolled "
                        />
                    </div>
                </Expansion>
            </div>

            {/*D. Resident Invites A Friend*/}
            <div className={classes.expansionMargin}>
                <Expansion
                    expanded={expanded === Labels.INVITE_FRIEND.MAIN}
                    name={Labels.INVITE_FRIEND.MAIN}
                    handleExpandedPanel={handleExpandedPanel}
                    header={Labels.INVITE_FRIEND.MAIN}
                >
                    <div className={`${classes.labelContainer} campaign-radio`}>
                        <InnerExpansion
                            open={subExpanded === Labels.INVITE_FRIEND.MAX}
                            header={Labels.INVITE_FRIEND.MAX}
                            onChange={onInnerExpansionChange}
                        >
                            <div className={`${classes.labelContainer} hyly-rsvp-form`}>
                                <Field onInput={onInput} fullWidth name="friendInviteMenuHeader" onChange={handleChange} value={values.friendInviteMenuHeader} label="Popup Title" />
                                <div className={classes.imageText}>Message</div>
                                <Field onInput={onInput} name="friendInviteMenuBody" onChange={handleChange} value={values.friendInviteMenuBody.replace(/\%reward\%/, "$" + values.reward)} multiline fullWidth variant="outlined" />
                                <div className={classes.shareText}>Select medium(s), a resident can use to refer a friend</div>
                                <FormControlLabel control={<Checkbox checked={values.emailEnabled} name="emailEnabled" onChange={onChange} />} label="Email" />
                                {/* <FormControlLabel control={<Checkbox checked={values.smsEnabled} name="smsEnabled" onChange={onChange} />} label="SMS" /> */}
                                <FormControlLabel control={<Checkbox checked={values.facebookEnabled} name="facebookEnabled" onChange={onChange} />} label="Facebook" />
                                <FormControlLabel control={<Checkbox checked={values.twitterEnabled} name="twitterEnabled" onChange={onChange} />} label="Twitter" />
                            </div>
                        </InnerExpansion>
                        <div className={classes.horizontalLine}></div>
                        <InnerExpansion
                            open={subExpanded === Labels.INVITE_FRIEND.DEFAULT}
                            header={Labels.INVITE_FRIEND.DEFAULT}
                            onChange={onInnerExpansionChange}
                        >
                            <EmailInvite
                                onInput={onInput}
                                classes={classes}
                                label_1="Email-Subject"
                                label_2="Email-Body"
                                label_3="SMS/Facebook/Twitter"
                                label_4="Email-Title"
                                name_1="residentInviteEmailSubject"
                                name_2="residentInviteEmailBody"
                                name_3="residentInviteSms"
                                name_4="friendInviteEmailHeader"
                                name_image="residentInviteImage"
                                value_1={values.residentInviteEmailSubject}
                                value_2={values.residentInviteEmailBody}
                                value_3={values.residentInviteSms.replace(/\%property\%/g, properties[values.propertyId])}
                                value_image={values.residentInviteImage}
                                value_4={values.friendInviteEmailHeader}
                                onChange={handleChange}
                                id={id}
                                assetCategory={assetCategory}
                                showNotification={showNotification}
                                aboveImageText="Upload an image, a resident can see when invited"
                            >
                                <div className={`hyly-rsvp-form`}>
                                    <Field onInput={onInput} className="hyly-half-input" name="tourCtaText" onChange={handleChange} value={values.tourCtaText} label="Tour CTA Text" />

                                    <Field onInput={onInput} className="hyly-half-input" name="tourCtaUrl" onChange={handleChange} value={values.tourCtaUrl.split("?")[0]} label="Tour CTA URL" />

                                    <Typography className={classes.utmContainer}>
                                        ?{values.tourCtaUrl.split("?")[1]}
                                    </Typography>

                                    <Field onInput={onInput} className="hyly-half-input" name="contactCtaText" onChange={handleChange} value={values.contactCtaText} label="Contact CTA Text" />

                                    <Field onInput={onInput} className="hyly-half-input" name="contactCtaUrl" onChange={handleChange} value={values.contactCtaUrl.split("?")[0]} label="Contact CTA URL" />

                                    <Typography className={classes.utmContainer}>
                                        ?{values.contactCtaUrl.split("?")[1]}
                                    </Typography>
                                </div>
                            </EmailInvite>
                        </InnerExpansion>
                        <div className={classes.horizontalLine}></div>
                        <InnerExpansion
                            open={subExpanded === Labels.INVITE_FRIEND.LANDING_PAGE}
                            header={Labels.INVITE_FRIEND.LANDING_PAGE}
                            onChange={onInnerExpansionChange}
                        >

                            <EmailInvite
                                onInput={onInput}
                                classes={classes}
                                label_1="Title"
                                label_2="Description"
                                name_1="landingPageTitle"
                                name_2="landingPageContent"
                                name_image="landingPageImage"
                                value_1={values.landingPageTitle}
                                value_2={values.landingPageContent}
                                value_image={values.landingPageImage}
                                onChange={handleChange}
                                id={id}
                                assetCategory={assetCategory}
                                showNotification={showNotification}
                                aboveImageText="Upload an image, a friend can see on the landing page"
                            />
                            {/* <div className={`${classes.labelContainer} hyly-rsvp-form`}>
                                <div className={classes.imageText}>Description</div>
                                <Field name="landingPageContent" onChange={handleChange} value={values.landingPageContent} multiline fullWidth variant="outlined" />
                            </div> */}
                        </InnerExpansion>
                        <div className={classes.horizontalLine}></div>
                        <InnerExpansion
                            open={subExpanded === Labels.INVITE_FRIEND.CONFIRMATION}
                            header={Labels.INVITE_FRIEND.CONFIRMATION}
                            onChange={onInnerExpansionChange}
                        >
                            <div className={`${classes.labelContainer} hyly-rsvp-form`}>
                                <Field onInput={onInput} fullWidth name="popupTitle" onChange={handleChange} value={values.popupTitle} label="Popup Title" />
                                <div className={classes.imageText}>Message</div>
                                <Field onInput={onInput} name="popupMessage" onChange={handleChange} value={values.popupMessage.replace(/\%reward\%/, "$" + values.reward)} multiline fullWidth variant="outlined" />
                            </div>
                        </InnerExpansion>
                    </div>

                </Expansion>
            </div>
            {/* D. Friend Gets In Touch */}
            {/* <div className={classes.expansionMargin}>
                <Expansion
                    expanded={expanded === Labels.GET_IN_TOUCH}
                    name={Labels.GET_IN_TOUCH}
                    handleExpandedPanel={handleExpandedPanel}
                    header={Labels.GET_IN_TOUCH}
                >
                    <div className={classes.marginStyle}>
                        <div className={`${classes.highLightText} ${classes.labelContainer}`}> Design CTAs for a friend to get in touch with community</div>
                        <div className={`${classes.labelContainer} hyly-rsvp-form`}>
                            <Field onInput={onInput} className="hyly-half-input" name="tourCtaText" onChange={handleChange} value={values.tourCtaText} label="Tour CTA Text" />

                            <Field onInput={onInput} className="hyly-half-input" name="tourCtaUrl" onChange={handleChange} value={values.tourCtaUrl.split("?")[0]} label="Tour CTA URL" />

                            <Typography className={classes.utmContainer}>
                                ?{values.tourCtaUrl.split("?")[1]}
                            </Typography>

                            <Field onInput={onInput} className="hyly-half-input" name="contactCtaText" onChange={handleChange} value={values.contactCtaText} label="Contact CTA Text" />

                            <Field onInput={onInput} className="hyly-half-input" name="contactCtaUrl" onChange={handleChange} value={values.contactCtaUrl.split("?")[0]} label="Contact CTA URL" />

                            <Typography className={classes.utmContainer}>
                                ?{values.contactCtaUrl.split("?")[1]}
                            </Typography>
                        </div>
                    </div>
                </Expansion>
            </div> */}
            {/* E. Resident Gets Discount */}
            <div className={classes.expansionMargin}>
                <Expansion
                    expanded={expanded === Labels.DISCOUNT_DETAIL}
                    name={Labels.DISCOUNT_DETAIL}
                    handleExpandedPanel={handleExpandedPanel}
                    header={Labels.DISCOUNT_DETAIL}
                >
                    <div className={classes.marginStyle}>
                        <div className={`${classes.highLightText} ${classes.labelContainer}`}> Reward confirmation will be sent to residents via Email/SMS</div>
                        <EmailInvite
                            onInput={onInput}
                            classes={classes}
                            label_1="Email-Subject"
                            label_2="Email-Body"
                            label_3="SMS"
                            label_4="Email-Title"
                            name_1="residentDiscountEmailSubject"
                            name_2="residentDiscountEmailBody"
                            name_3="residentDiscountEmailSms"
                            name_4="rewardEmailHeader"
                            name_image="residentDiscountImage"
                            value_1={values.residentDiscountEmailSubject}
                            value_2={values.residentDiscountEmailBody.replace(/\%reward\%/, "$" + values.reward)}
                            value_3={values.residentDiscountEmailSms?.replace(/\%reward\%/, "$" + values.reward)}
                            value_image={values.residentDiscountImage}
                            value_4={values.rewardEmailHeader}
                            onChange={handleChange}
                            id={id}
                            assetCategory={assetCategory}
                            showNotification={showNotification}
                            aboveImageText="Upload an image, a resident can see when reward is received "
                            onFocus={handleFocus}
                        />
                    </div>
                </Expansion>
            </div>
        </div>
    );
})

export default React.memo(EditForm);
